module.exports = __webpack_public_path__ + "img/Sharing1.0d56193c.svg";